// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"51b5d006","131":"13db431f","347":"bf68f9a6","485":"d245b014","871":"befbbb30","968":"daae0450","969":"79354ac2","973":"befbbb30"}[chunkId] + ".chunk.css";
};